module.exports = __webpack_public_path__ + "static/img/icon.42ddd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/icon.png
// module id = hUY4
// module chunks = 44